import mutations from './laboratoryTypes.mutations'
import actions from './laboratoryTypes.actions'
import getters from './laboratoryTypes.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
